import { FolderOpenIcon } from '@heroicons/react/24/outline';

export default function EmptyState({ icon: Icon = FolderOpenIcon, title = 'No items found', description, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <Icon className="h-12 w-12 text-slate-300 mb-4" />
      <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
      {description && <p className="mt-1 text-sm text-slate-500">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
